'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React from 'react'

import { cn } from "./ui/utils"
import { buttonVariants } from "./ui/button"
import { useTenantOptional } from "./TenantProvider"

interface NavLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode,
  className?: string,
  isPending?: boolean,
  size?: "sm" | "lg",
  to: string,
  variant?: "default" | "secondary" | "outline"
}

export default function NavLink({ to, children, variant, size, className, isPending, ...props }: NavLinkProps) {
  const pathname = usePathname()
  const tenant = useTenantOptional()
  const href = tenant ? tenant.appendTenantToPath(to) : to
  const isActive = pathname === to || pathname === href.split('?')[0]
  let augmentedClassName = cn(buttonVariants({ variant, size, className }), "font-bold transform transition duration-300 hover:scale-105 pointer-events-auto")
  if (!variant || variant === "default") {
    augmentedClassName = cn(augmentedClassName, "p-4")
  } else if (variant === "secondary") {
    augmentedClassName = cn(augmentedClassName, "shadow-none")
  } else if (variant === "outline") {
    augmentedClassName = cn(augmentedClassName, "bg-transparent border-2 border-primary-base text-primary-base")
  }
  if (size === "sm") {
    augmentedClassName = cn(augmentedClassName, "text-sm")
  } else if (size === "lg") {
    augmentedClassName = cn(augmentedClassName, "text-lg")
  }
  if (isPending) {
    augmentedClassName = cn(augmentedClassName, "pointer-events-none")
  }

  return (
    <Link className={cn(augmentedClassName, isActive ? 'active' : '')} href={href} {...props}>
      {children}
    </Link>
  );
}
